import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 overflow-y-auto"
}
const _hoisted_2 = { class: "flex items-center justify-between flex-shrink-0 h-16 px-6 border-b" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", {
  id: "slide-over-title",
  class: "text-lg font-bold text-gray-900"
}, " Standard Selection ", -1)
const _hoisted_4 = { class: "flex items-center ml-3 h-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "relative flex-grow" }
const _hoisted_8 = { class: "h-full p-6 bg-gray-100" }
const _hoisted_9 = { class: "mb-8 border-b border-gray-300" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-3 font-medium" }, " Please select standards", -1)
const _hoisted_11 = { class: "multiselect-multiple-label" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "block mb-3 font-medium" }
const _hoisted_14 = {
  key: 0,
  class: "ml-1 text-red-500"
}
const _hoisted_15 = ["onUpdate:modelValue", "onChange"]
const _hoisted_16 = { value: "all" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "each" }, " Answer for each standard ", -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 1,
  class: "flex justify-end flex-shrink-0 px-4 py-4 border-t"
}
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.standards.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
              }, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.selections,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selections) = $event)),
                  options: _ctx.standards,
                  mode: "multiple",
                  placeholder: "Search standards",
                  "value-prop": "title",
                  "track-by": "title",
                  label: "title",
                  searchable: true,
                  "close-on-select": false
                }, {
                  multiplelabel: _withCtx(({ values }) => [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(values.length) + " standards selected ", 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              (_ctx.selections.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field,
                        class: "p-4 mb-6 bg-white border rounded shadow-sm"
                      }, [
                        _createElementVNode("p", _hoisted_13, [
                          _createTextVNode(_toDisplayString(field.label) + " ", 1),
                          (field.required)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, " * "))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((field.view) = $event),
                          class: "block px-4 py-2 pr-10 mb-6 border border-gray-300 rounded shadow-sm cursor-pointer focus:ring-brand",
                          onChange: ($event: any) => (_ctx.onChangeInputMethod(field.name, $event.target.value))
                        }, [
                          _createElementVNode("option", _hoisted_16, " Answer for all standards (" + _toDisplayString(_ctx.selections.length) + ") ", 1),
                          _hoisted_17
                        ], 40, _hoisted_15), [
                          [_vModelSelect, field.view]
                        ]),
                        (field.view === 'all')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), {
                                modelValue: _ctx.formValues[field.name],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.formValues[field.name]) = $event),
                                type: field.type,
                                options: field.options,
                                required: field.required,
                                value: field.value,
                                error: _ctx.formErrors[field.name],
                                onChange: ($event: any) => (_ctx.setAll(field.name, $event.target.value)),
                                onInput: ($event: any) => (_ctx.setAll(field.name, $event.target.value)),
                                onBlur: ($event: any) => (_ctx.setAll(field.name, $event.target.value)),
                                onFileUpload: ($event: any) => (_ctx.setAll(field.name, $event.target.files[0].name))
                              }, null, 40, ["modelValue", "onUpdate:modelValue", "type", "options", "required", "value", "error", "onChange", "onInput", "onBlur", "onFileUpload"]))
                            ]))
                          : _createCommentVNode("", true),
                        (field.view === 'each')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selections, (selection) => {
                                return (_openBlock(), _createElementBlock("div", { key: selection }, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), {
                                    modelValue: _ctx.formValues[selection + field.name],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.formValues[selection + field.name]) = $event),
                                    label: _ctx.getStandard(selection).title,
                                    type: field.type,
                                    options: field.options,
                                    value: field.value,
                                    error: _ctx.formData[selection].errors[field.name],
                                    onChange: ($event: any) => (_ctx.setOne(selection, field.name, $event.target.value)),
                                    onInput: ($event: any) => (_ctx.setOne(selection, field.name, $event.target.value)),
                                    onBlur: ($event: any) => (_ctx.setOne(selection, field.name, $event.target.value)),
                                    onFileUpload: ($event: any) => (_ctx.setOne(selection, field.name, $event.target.files[0].name))
                                  }, null, 40, ["modelValue", "onUpdate:modelValue", "label", "type", "options", "value", "error", "onChange", "onInput", "onBlur", "onFileUpload"]))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.declarationSchema, (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: field,
                  class: "mb-4"
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), {
                    label: field.label,
                    type: field.type,
                    options: field.options,
                    value: field.value,
                    required: field.required,
                    error: _ctx.formErrors[field.name]
                  }, null, 8, ["label", "type", "options", "value", "required", "error"]))
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.standards.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "submit",
            class: _normalizeClass(["inline-flex justify-center px-4 py-2 ml-4 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-brand", !_ctx.formValid ? 'opacity-25' : '']),
            disabled: !_ctx.formValid,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmit()))
          }, " Save ", 10, _hoisted_21)
        ]))
      : (_openBlock(), _createBlock(_component_LoadingSpinner, {
          key: 2,
          message: "Loading Section"
        }))
  ], 64))
}